module.exports = __webpack_public_path__ + "img/vf3.da692d29.png";